import mushroomIcon from '../assets/loading-mushroom.svg';
import styles from './ReconnectingBanner.module.css';

export function ReconnectingBanner() {
  return (
    <div className={styles.banner} role="status" aria-label="Reconnecting">
      <img
        src={mushroomIcon}
        alt=""
        className={styles.spinner}
        aria-hidden="true"
      />
      <span className={styles.text}>Reconnecting...</span>
    </div>
  );
}
